import React, { useContext } from 'react';
import { Text, View } from 'react-native';
import { Feather as Icons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';

import { Container, Content, ContentProblem, DateProblem, Header, IconFE, NameProduct, TextProblem, Title, Image } from './styles';
import RouteContext from '../../../context/route';

const ViewProblem = () => {
    const navigation = useNavigation();
    const { individualOrder, reportProblem, loading } = useContext(RouteContext);
    const dateFinalize = new Date(individualOrder.date_status_change);

    function backPage(){
        navigation.goBack();
    };

    return(
        <Container>
            <Header>
                <IconFE 
                    name="arrow-left" 
                    size={25} 
                    color="#fff"
                    onPress={backPage}
                />
                {individualOrder.order_status === 1 && <Title>Visualizar comprovante</Title>}
                {individualOrder.order_status === 2 && <Title>Visualizar problemas</Title>}
                <View/>
            </Header>

            <Content>
                <NameProduct>Número da nota{'\n'}{individualOrder.invoice_number}</NameProduct>
                {!!individualOrder.image && (
                    <Image source={{uri: individualOrder.image }} />
                )}

                {!!individualOrder.problem && (
                    <ContentProblem>
                        <TextProblem>{individualOrder.problem}</TextProblem>
                        <DateProblem>{dateFinalize.toLocaleDateString()}</DateProblem>
                    </ContentProblem>
                )}
            </Content>
        </Container>
    );
};

export default ViewProblem;